import { z } from 'zod';
import { IsoDateTime } from './_common.js';
export const AnalyticsPeriod = z.enum(['1h', '24h', '7d', '30d', '90d']);
export const AnalyticsDashboardRequest = z.object({
    period: AnalyticsPeriod.default('24h'),
    game_id: z.string().optional(),
});
export const AnalyticsDashboardResponse = z.object({
    ts: IsoDateTime,
    period: AnalyticsPeriod,
    dau: z.number().int(),
    wau: z.number().int(),
    mau: z.number().int(),
    new_users: z.number().int(),
    arpu_usd_cents: z.number().int(),
    arppu_usd_cents: z.number().int(),
    paying_users: z.number().int(),
    iap_revenue_usd_cents: z.number().int(),
    retention_d1_pct: z.number(),
    retention_d7_pct: z.number(),
    retention_d30_pct: z.number(),
    spins_total: z.number().int(),
    spins_per_user: z.number(),
    fever_triggered: z.number().int(),
    fever_per_active_user: z.number(),
    k_factor: z.number(),
    invites_generated: z.number().int(),
    invites_redeemed: z.number().int(),
    gifts_sent: z.number().int(),
    gifts_claimed: z.number().int(),
    avg_session_length_seconds: z.number(),
    room_density_avg: z.number(),
    observed_rtp_by_game: z.record(z.number()),
});
export const AnalyticsFunnelStep = z.object({
    step: z.string(),
    users: z.number().int(),
    conversion_pct_from_prev: z.number(),
});
export const AnalyticsFunnelKind = z.enum([
    'new_user_first_fever',
    'invite_to_paying',
    'first_purchase',
    'd1_to_d7_retention',
    'leaderboard_engagement',
]);
export const AnalyticsFunnelRequest = z.object({
    kind: AnalyticsFunnelKind,
    period: AnalyticsPeriod.default('30d'),
    cohort_id: z.string().optional(),
});
export const AnalyticsFunnelResponse = z.object({
    kind: AnalyticsFunnelKind,
    period: AnalyticsPeriod,
    steps: z.array(AnalyticsFunnelStep),
    overall_conversion_pct: z.number(),
});
export const AnalyticsCohortRetentionRequest = z.object({
    cohort_def: z.enum(['signup_week', 'first_purchase_week']),
    weeks: z.number().int().min(1).max(26).default(8),
});
export const AnalyticsCohortRetentionRow = z.object({
    cohort_label: z.string(),
    cohort_size: z.number().int(),
    weekly_retention: z.array(z.number()),
});
export const AnalyticsCohortRetentionResponse = z.object({
    rows: z.array(AnalyticsCohortRetentionRow),
});
export const AnalyticsRevenueBreakdownRequest = z.object({
    period: AnalyticsPeriod.default('30d'),
    group_by: z.enum(['country', 'sku', 'tier', 'cohort']).default('country'),
});
export const AnalyticsRevenueBreakdownRow = z.object({
    bucket: z.string(),
    revenue_usd_cents: z.number().int(),
    paying_users: z.number().int(),
    arppu_usd_cents: z.number().int(),
});
export const AnalyticsRevenueBreakdownResponse = z.object({
    group_by: z.string(),
    rows: z.array(AnalyticsRevenueBreakdownRow),
    total_usd_cents: z.number().int(),
});
export const NorthStarCohort = z.enum(['all', 'fresh', 'invited', 'returning']);
export const NorthStarMetricKey = z.enum([
    'first_spin_within_10s_rate',
    'tenth_spin_within_30s_rate',
    'heat_70_within_90s_rate',
    'fever_fire_after_heat_70_rate',
    'first_lucky_fever_within_180s_rate',
]);
export const NorthStarMetric = z.object({
    key: NorthStarMetricKey,
    label: z.string(),
    numerator: z.number().int(),
    denominator: z.number().int(),
    rate_pct: z.number(),
    target_pct: z.number(),
    status: z.enum(['ok', 'warn', 'critical', 'no_data']),
});
export const NorthStarCohortSummary = z.object({
    cohort: NorthStarCohort,
    users: z.number().int(),
    metrics: z.array(NorthStarMetric),
});
export const NorthStarDashboardRequest = z.object({
    period: AnalyticsPeriod.default('24h'),
});
export const NorthStarDashboardResponse = z.object({
    ts: IsoDateTime,
    period: AnalyticsPeriod,
    window_start: IsoDateTime,
    window_end: IsoDateTime,
    cohorts: z.array(NorthStarCohortSummary),
    data_quality: z.object({
        users_considered: z.number().int(),
        synthetic_events_excluded: z.number().int(),
        sessions_missing_heat_pct: z.number().int(),
    }),
});
//# sourceMappingURL=analytics.js.map